module.exports = __webpack_public_path__ + "img/symbol_3.8ba09de1.png";